import { render } from "./SideIntroduction.vue?vue&type=template&id=baababfe"
import script from "./SideIntroduction.vue?vue&type=script&lang=js"
export * from "./SideIntroduction.vue?vue&type=script&lang=js"

import "./SideIntroduction.vue?vue&type=style&index=0&id=baababfe&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__